import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const AnchorLinkContext = React.createContext(false);
function AnchorLinkProvider({ children }) {
    return _jsx(AnchorLinkContext.Provider, { value: true, children: children });
}
function useIsWithinAnchorLink() {
    return React.useContext(AnchorLinkContext);
}
export { AnchorLinkProvider, useIsWithinAnchorLink };
//# sourceMappingURL=AnchorLinkContext.js.map